// eslint-disable-next-line import/prefer-default-export, no-shadow
export enum ManufaturersActionTypes {
    GET_MANUFACTURERS = 'GET_MANUFACTURERS',
    GET_ENGINE_CAPCITY = 'GET_ENGINE_CAPCITY'
}
  